import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import tw from "./locales/tw.json";
import ee from "./locales/ee.json";
import ha from "./locales/ha.json";
import dag from "./locales/dag.json";
import ga from "./locales/ga.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tw: { translation: tw },
      ee: { translation: ee },
      ha: { translation: ha },
      dag: { translation: dag },
      ga: { translation: ga },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "tw", "ee", "ha", "dag", "ga"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
